import { AiOutlineHome, AiOutlineAppstore } from 'react-icons/ai'
import { MdErrorOutline, MdOutlineList } from 'react-icons/md'
import { IoLogOutOutline } from 'react-icons/io5'

export const data = [
    { Icon: AiOutlineHome, text: 'Home' },
    {
        Icon: MdErrorOutline,
        text: 'List Certificate',
    },
    {
        Icon: MdErrorOutline,
        text: 'Messages',
    },
    {
        Icon: MdOutlineList,
        text: 'Waiting List',
    },
    {
        Icon: IoLogOutOutline,
        text: 'Logout',
    },
].map((item, index) => ({ ...item, id: index + 1 }));